// extracted by mini-css-extract-plugin
export default {"user":"components-userGroup-UserGroupToUsersWidget-UserGroupToUsersWidgetUser-__user"};